<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="px-7 py-7" height="100%">
          <v-row>
            <v-col cols="12">
              <SimplePageHeader
                title="My Profile"
              ></SimplePageHeader>
            </v-col>
          </v-row>
          <v-row class="align-center">
            <v-col cols="4" md="5" align="center">
              <v-icon large class="avatar">account_circle</v-icon>
            </v-col>
            <v-col cols="8" md="7">
              <v-row>
                <v-col cols="12">
                  <p>
                    {{ fullName }}
                    <br>
                    {{ emailAddress }}
                  </p>
                  <v-btn
                    block
                    color="primary"
                    @click="editUserPassword"
                  >Change Password
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <UserPasswordChangeModal
      :userID="currentUserId"
      :showCurrentPasswordField="true"
      ref="userPasswordModal"
    ></UserPasswordChangeModal>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { getCurrentUser } from '@/lib/authentication'
import { DynamicModal } from '@/components/dialogs'
import UserPasswordChangeModal from '@/components/users/UserPasswordChangeModal'
import { SimplePageHeader } from '@/components/pageComponents'

export default {
  components: {
    DynamicModal,
    UserPasswordChangeModal,
    SimplePageHeader
  },
  computed: {
    ...mapFields('user', [
      'id',
      'firstName',
      'fullName',
      'emailAddress'
    ]),
    currentUserId () {
      const currentUser = getCurrentUser()
      if (!currentUser || !currentUser.id) {
        return null
      }
      return currentUser.id
    }
  },
  data () {
    return {
      showModal: false,
      modalTitle: ''
    }
  },
  methods: {
    ...mapActions('user', [
      'getUser'
    ]),
    loadUserData () {
      this.getUser({ id: this.currentUserId })
    },
    editUserPassword () {
      this.$refs.userPasswordModal.showModal()
    },
    closeDialog () {
      this.showModal = false
    }
  },
  created () {
    this.loadUserData()
  }
}
</script>

<style scoped>
.avatar {
  font-size: 100px !important;
}
</style>
